import { getIamBatteryPathname } from 'pages/CatalogPage/common/QuickAccess/useQuickAccessLinks';

export const useIsBatteryUrl = (): boolean => {
  const urlPathname = window.location.pathname;
  const iamBatteryPathname = getIamBatteryPathname();
  return urlPathname.includes(iamBatteryPathname);
};
